import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

import { StyledIconButton } from './icon-button.styled';
import { TIconButtonProps } from './icon-button.types';

export const IconButton: React.FC<TIconButtonProps> = ({
  variant,
  clicked,
  loading,
  disabled,
  tooltip,
  children,
  ...props
}) => {
  return (
    <Tooltip title={tooltip} wrapper="default">
      <StyledIconButton
        $variant={variant}
        $clicked={clicked}
        disabled={disabled || loading}
        {...props}
      >
        {loading ? (
          <CircularProgress size="0.75rem" color="inherit" />
        ) : (
          children
        )}
      </StyledIconButton>
    </Tooltip>
  );
};
